export const getNotificationsState = state => state.notifications
